import { useEffect, useMemo, useState } from "react";
import { Cat, Dog, Rocket, Fish, Bird, Ghost, Rabbit, Turtle } from "lucide-react";

const ICONS = [Cat, Dog, Rocket, Fish, Bird, Ghost, Rabbit, Turtle];
const COLORS = ["#FF8FC7", "#3DCCC7", "#FFD23F", "#B8F2C9", "#9BD0FF", "#FFB86B", "#E0D7FF", "#FF6B4A"];
const shuffle = (a) => a.map((v) => [Math.random(), v]).sort((x, y) => x[0] - y[0]).map((x) => x[1]);

export const MemoryMatch = ({ onFinish }) => {
  const deck = useMemo(() => shuffle([...Array(6).keys()].flatMap((i) => [i, i])).map((k, idx) => ({ k, idx })), []);
  const [open, setOpen] = useState([]);
  const [found, setFound] = useState([]);
  const [moves, setMoves] = useState(0);

  useEffect(() => {
    if (open.length !== 2) return;
    const [a, b] = open;
    const t = setTimeout(() => {
      if (deck[a].k === deck[b].k) setFound((f) => [...f, deck[a].k]);
      setOpen([]);
    }, deck[a].k === deck[b].k ? 300 : 800);
    return () => clearTimeout(t);
  }, [open, deck]);

  useEffect(() => {
    if (found.length === 6) onFinish(moves, moves <= 10 ? 3 : moves <= 14 ? 2 : 1);
  }, [found, moves, onFinish]);

  const flip = (i) => {
    if (open.length === 2 || open.includes(i) || found.includes(deck[i].k)) return;
    if (open.length === 1) setMoves((m) => m + 1);
    setOpen((o) => [...o, i]);
  };

  return (
    <div className="max-w-md mx-auto">
      <p className="font-display text-lg mb-4" data-testid="memory-moves">Moves: {moves} · Pairs: {found.length}/6</p>
      <div className="grid grid-cols-4 gap-2.5 sm:gap-3">
        {deck.map(({ k }, i) => {
          const up = open.includes(i) || found.includes(k);
          const Icon = ICONS[k];
          return (
            <button key={i} data-testid={`memory-card-${i}`} data-key={k} onClick={() => flip(i)} aria-label={up ? "card" : "hidden card"}
              className={`aspect-square rounded-2xl border-[3px] border-[#1B1A2E] grid place-items-center shadow-[3px_3px_0_0_#1B1A2E] transition-transform duration-300 active:scale-95 ${found.includes(k) ? "opacity-70" : ""}`}
              style={{ background: up ? COLORS[k] : "#1B1A2E", transform: up ? "rotateY(0)" : "rotateY(180deg)" }}>
              {up ? <Icon size={36} /> : <span className="text-[#FFD23F] font-display text-3xl font-bold">?</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
};
